'use strict';

const headerApp = new Vue({
    el: '#header-app',
    // Shared app state
    data: {
        navigation: {
            open: false,
            openSubMenus: []
        },
    },
    methods: {
        toggleMenu() {
            this.navigation.open = !this.navigation.open;

            $("#app").toggleClass('menu-open');
        },
        toggleSubMenu: function (id, openSubMenus) {
            let alreadyOpenedSubMenu = openSubMenus.indexOf(id);

            if (alreadyOpenedSubMenu > -1) {
                openSubMenus.splice(alreadyOpenedSubMenu, 1);
            } else {
                openSubMenus.push(id);
            }
        },
        subMenuIsOpen: function (id, openSubMenus) {
            return openSubMenus.indexOf(id) > -1;
        }
    },
});
